<template>
  <div :class="[ _isMobile() ? 'mobile' : '','courseLayout']">
    <Header id="header"/>
    <div class="cms">
      <router-view />
    </div>
    <a-back-top />
    <!-- <Footer /> -->
  </div>
</template>

<script>
import { mixinDevice } from "@/utils/mixin.js";
import Header from "@/components/header/HeaderWayi";
import Header2 from "@/components/header/Header2";
import Header3 from "@/components/header/Header3";
import Footer from "@/components/footer/Footer";
export default {
  name: "CmdLayout",
  mixins: [mixinDevice],
  components: {
    Header,
    Header2,
    Header3,
    Footer,
  },
  data() {
    return {
      tenantConfig: {},
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
  },
};
</script>
<style>
a * {
  transition: all 0.1s ease;
}
</style>
<style lang="less" scoped>
.courseLayout {
  width: 100%;
  min-height: 100vh;
  height: auto;
  // background-image: url('~@/theme/wayi/assets/imgs/course/background.png');
  // background-size: 100% auto;
  // background-repeat:repeat-y;
  // padding-top: 69px;
  .cms {
    width: 100%;
    box-sizing: border-box;
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
}
.mobile{
  .cms{
    padding: 0px;
  }
}
</style>